import { FeatureEnum } from '@/features/game/levels/config/features'
import { z } from 'zod'

const skillTreeLeaf = z.object({
    feature: FeatureEnum,
})
export type SkillBranch = z.infer<typeof skillTreeLeaf> & {
    branches: SkillBranch[]
}
const SkillTreeBranchSchema: z.ZodType<SkillBranch> = skillTreeLeaf.extend({
    branches: z.lazy(() => SkillTreeBranchSchema.array()),
})

export const SkillTreeSchema = z.object({
    // not sure what to name this, time, planning, execution, clarity, organization, coordination, management
    coordination: SkillTreeBranchSchema.array(),
    vision: SkillTreeBranchSchema.array(),
    insight: SkillTreeBranchSchema.array(),
    energy: SkillTreeBranchSchema.array(),
    rest: SkillTreeBranchSchema.array(),
})

export type SkillTree = z.infer<typeof SkillTreeSchema>

type Pillar = keyof SkillTree

export const PILLAR_TO_INFO: Record<Pillar, { name: string; description: string }> = {
    coordination: {
        name: 'Prioritization',
        description: 'Knowing what to do and when to do it.',
    },
    vision: {
        name: 'Vision',
        description: 'The ability to see the big picture and set long-term goals.',
    },
    insight: {
        name: 'Insight',
        description: 'Self-reflection and understanding of your own strengths and weaknesses.',
    },
    energy: {
        name: 'Energy',
        description: 'The ability to maintain high levels of energy and motivation.',
    },
    rest: {
        name: 'Rest',
        description: 'The ability to take breaks and recharge effectively.',
        // includes sleep.
    },
}
